import styled from '@emotion/styled'

export const Description = styled.span`
  font-weight: 400;
  font-size: 12px;
  line-height: 140%;
  letter-spacing: 0%;
  vertical-align: middle;
  color: #77778e;
  text-align: left;
`
